import { WORKGROUP_CARGO_AGENT, WORKGROUP_OPS_AGENT } from "../constants";

//#region Common Contract constants
export const VOLUNTARY_OT_PAGE = "Voluntary OT List";
export const BEFORE = "B: Before";
export const AFTER = "A: After";
export const EITHER = "E: Either";
export const BOTH = "X: Both";

export const AM = "AM";
export const PM = "PM";

export const OPS_CARGO_AGENTS_WORKGROUP_LIST = [WORKGROUP_CARGO_AGENT, WORKGROUP_OPS_AGENT];
//#endregion

//#region IAM constants
export const CONTINUOUS_WITH_PREFERENCES_IAM = [BEFORE, AFTER, EITHER, BOTH];

export const _4_PLUS_TO_5_HOURS = "4+ to 5 hours";
export const _4_PLUS_TO_LESS_THAN_8_HOURS = "4+ to < 8 hours";
export const FULL_8_HOURS = "Full 8 hours";
export const CALLOUT_OT_HOURS_PREFERENCES_LIST = [_4_PLUS_TO_5_HOURS, _4_PLUS_TO_LESS_THAN_8_HOURS, FULL_8_HOURS];

export const CALLOUT_OT_TIME_OF_DAY_PREFERENCES_LIST = [AM, PM];
//#endregion

//#region TWU constants
export const OT_STATUS_A = "A: 1st Sked. Day Off";
export const OT_STATUS_B = "B: Reg. Work Day";
export const OT_STATUS_C = "C: 2nd Sked. Day Off";
export const OT_STATUS_D = "D: Shift Trade";
export const OT_STATUS_E = "E: Shift Giveaway";
export const OT_STATUS_F = "F: Freeday/FTO";
export const OT_STATUS_G = "G: Vacations";
export const OT_STATUS_H = "H: EAD";
export const OT_STATUS_LIST = [
  OT_STATUS_A,
  OT_STATUS_B,
  OT_STATUS_C,
  OT_STATUS_D,
  OT_STATUS_E,
  OT_STATUS_F,
  OT_STATUS_G,
  OT_STATUS_H,
];

export const CONTINUOUS_WITH_PREFERENCES_TWU = [BEFORE, AFTER, BOTH];

export const OVERNIGHT = "Overnight";
export const AIR_FREIGHT_AM = "Air/Freight AM";
export const AIR_FREIGHT_PM = "Air/Freight PM";
export const CHARTER = "Charter";
export const CALLOUT_OT_ASSIGNMENT_PREFERENCES_LIST = [AM, PM, OVERNIGHT];
export const CALLOUT_OT_ASSIGNMENT_OPS_CARGO_PREFERENCES_LIST = [
  AM,
  PM,
  OVERNIGHT,
  AIR_FREIGHT_AM,
  AIR_FREIGHT_PM,
  CHARTER,
];

export const MIN_TWU_SHIFT_LENGTH_MINUTES = 30;
//#endregion

//#region Error Messages
export const START_END_TIME_IS_REQUIRED_ERROR = "Start and End Time are required";
export const SCHEDULED_DAYS_OFF_AT_LEAST_TWO_ERROR = "At least 2 days must be selected";
export const AT_LEAST_ONE_SHIFT_IN_FUTURE_ERROR = "At least one shift must end in the future";
export const PREFERENCE_SELECTED_DUPLICATION_ERROR = "This preference cannot be duplicated";
export const AT_LEAST_ONE_PREFERENCE_MUST_BE_SELECTED_ERROR = "At least one preference must be selected";
export const MUST_SELECT_AT_LEAST_ONE_TIME_OF_DAY_PREFERENCE_ERROR = "Must select at least one Time of Day preference";
export const MUST_SELECT_AT_LEAST_ONE_HOURS_PREFERENCE_ERROR = "Must select at least one # of Hours preference";
export const OT_STATUS_IS_REQUIRED_ERROR = "OT Status is required";
export const OT_ELIGIBILITY_EMPLOYEE_WARNING =
  "Unable to process request because you will not be working in this station during that time.";
//#endregion

//#region API Constants
export const OVERTIME_SERVICE_API_OT_EVENT_ELIGIBILITY = "otEventEligibilityService";
export const OVERTIME_SERVICE_API_ADD_OT_EVENT = "addVOTEvent";
export const OVERTIME_SERVICE_API_GET_VOLUNTARY_OT_LIST = "getVOTList";
//#endregion
